<template>
  <v-container fluid class="tabs-content__container">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Schedule & Budget
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="blue-grey lighten-1" style="vertical-align:text-top; margin-top:3px">info</v-icon>
            </template>
              <span>Select the schedule and budget of your ad campaign</span>
          </v-tooltip>
        </h1>
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="5">
        <div class="flight-details__row">
          <h3 class="flight-details__row-label">Schedule</h3>
          <v-container fluid>
            <the-date-picker
              v-if="initialDates.length >= 2"
              :initialDates="initialDates"
              :pickerOptions="pickerOptions"
              @setDate="setDate"
            />
          </v-container>
        </div>
        <v-divider class="mt-3" />
        <div class="flight-details__row">
          <h3 class="flight-details__row-label">Budget</h3>
          <v-container fluid>
            <v-layout column>
              <input-element
                placeholder="Total"
                @changeValueInput="setTotal"
                @disable="setTotalActive"
                :disabled="!totalActive"
                :value="total"
              ></input-element>
              <input-element
                placeholder="Daily"
                @changeValueInput="setDaily"
                @disable="setTotalActive"
                :disabled="totalActive"
                :value="daily"
              ></input-element>
            </v-layout>
            <v-flex xs12>
              <span>You will spend a <strong>total of ${{ quantity | thousands }}</strong> for your campaign</span>
            </v-flex>
          </v-container>
        </div>
        <v-divider class="mt-3" />
        <div class="flight-details__row">
          <h3 class="flight-details__row-label">Campaign name</h3>
          <v-container fluid>
            <v-text-field
              name="campaing-name"
              label="Name your ad campaign"
              :value="campaign.name"
              @input="setName"
            />
          </v-container>
        </div>
      </v-col>
    </v-row>
    <div class="tabs-content__container-action">
      <v-row>
        <v-btn @click="previousPage">Previous</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!next"
          @click="nextPage"
        >Next</v-btn>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import moment from 'moment'
import InputElement from './InputElement.vue'
import TheDatePicker from '../../helpers/TheDatePicker.vue'
export default {
  name: 'flight-details',
  components: {
    InputElement,
    TheDatePicker
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      totalActive: true,
      initialDates: [],
      pickerOptions: {
        disabledDate: (d) => d < moment().subtract(1, 'days')
      }
    }
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    if (this.campaign.start_time) {
      this.initialDates.push(this.$moment(this.campaign.start_time)._d)
      this.startDate = this.campaign.start_time
    } else {
      this.initialDates.push(this.$moment()._d)
      this.startDate = this.initialDates[0]
    }
    if (this.campaign.end_time) {
      this.initialDates.push(this.$moment(this.campaign.end_time)._d)
      this.endDate = this.campaign.end_time
    } else {
      this.initialDates.push(this.$moment().add(14, 'days')._d)
      this.endDate = this.initialDates[1]
    }
    this.$emit('setCampaignProperty', 'start_time', this.$moment(this.initialDates[0]).format('YYYY-MM-DD hh:mm:ss'))
    this.$emit('setCampaignProperty', 'end_time', this.$moment(this.initialDates[1]).format('YYYY-MM-DD hh:mm:ss'))
    if (this.campaign.selectedBudget === 'daily_budget') this.totalActive = false
  },
  computed: {
    total () {
      return this.campaign.lifetime_budget
    },
    daily () {
      return this.campaign.daily_budget
    },
    quantity () {
      if (this.totalActive) return this.total
      if (!this.startDate || !this.endDate) return 0
      let difference = this.$moment(this.endDate).diff(this.$moment(this.startDate), 'days')
      return this.daily * difference
    },
    next () {
      if (this.quantity > 0 && this.campaign.name.length) return true
      return false
    }
  },
  filters: {
    thousands: function (number) {
      return Number(number).toFixed(2).toString().toLocaleString()
    }
  },
  methods: {
    setTotalActive () {
      this.totalActive = !this.totalActive
      if (this.totalActive) {
        this.$emit('setCampaignProperty', 'selectedBudget', 'lifetime_budget')
      } else {
        this.$emit('setCampaignProperty', 'selectedBudget', 'daily_budget')
      }
    },
    setDate (dates) {
      this.startDate = dates[0]
      this.endDate = dates[1]
      this.$emit('setCampaignProperty', 'start_time', this.$moment(dates[0]).format('YYYY-MM-DD hh:mm:ss'))
      this.$emit('setCampaignProperty', 'end_time', this.$moment(dates[1]).format('YYYY-MM-DD hh:mm:ss'))
    },
    setTotal (val) {
      this.$emit('setCampaignProperty', 'lifetime_budget', val)
    },
    setDaily (val) {
      this.$emit('setCampaignProperty', 'daily_budget', val)
    },
    nextPage () {
      this.$emit('next')
    },
    previousPage () {
      this.$emit('previous')
    },
    setName (val) {
      this.$emit('setCampaignProperty', 'name', val)
    }
  }
}
</script>
<style lang="scss">
  .flight-details__row {
    display: flex;
    align-items: center;
    &-label {
      min-width: 100px;
      margin-right: 24px;

    }
  }
</style>
